import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-443f2194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center gap-5" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "required mb-1" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = {
  for: "",
  class: "required mb-1"
}
const _hoisted_6 = { class: "w-100 px-10" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Conditions", -1))
const _hoisted_9 = { class: "d-flex mt-5" }

import moment from "moment";
import { nextTick, ref, watch } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import SimpleForm from "@/components/SimpleForm.vue";
import { isDateInDST_US } from "@/core/plugins/TimerService";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesRebateExportModal',
  setup(__props, { expose: __expose }) {

const modalRef = ref();
const isLoading = ref(false);
const exporting = ref(false);
const period = ref([] as any);

const defaultTime = ref<[Date, Date]>([
  new Date(2000, 1, 1, 0, 0, 0),
  new Date(2000, 2, 1, 23, 59, 59),
]);

const criteria = ref({
  status: "",
  salesAccountUid: "",
  tradeAccountNumber: "",
  ticket: "",
  from: null,
  to: null,
} as any);

const formData = ref({
  type: ReportRequestTypes.SalesRebateSumByAccountForTenant,
} as any);

const submit = async () => {
  exporting.value = true;

  formData.value.query = {
    from: criteria.value.from,
    to: criteria.value.to,
    salesAccountUid: criteria.value.salesAccountUid,
    tradeAccountNumber: criteria.value.tradeAccountNumber,
    ticket: criteria.value.ticket,
    status: criteria.value.status,
  };

  try {
    await TenantGlobalService.createReportRequestDownload(formData.value).then(
      MsgPrompt.success(
        "Request has been submitted, please check the Report Record"
      ).then(() => {
        exporting.value = false;
        resetCriteria();
        formData.value.name = null;
        hide();
      })
    );
  } catch (error) {
    MsgPrompt.error(error);
    exporting.value = false;
  }
};

const resetCriteria = () => {
  period.value = [];
  criteria.value.status = "";
  criteria.value.salesAccountUid = "";
  criteria.value.tradeAccountNumber = "";
  criteria.value.ticket = "";
};

const show = async (_criteria?: any, _period?: any) => {
  criteria.value = _criteria;
  period.value = _period;

  await nextTick();
  modalRef.value?.show();
};

const hide = () => {
  modalRef.value?.hide();
};

watch(
  () => period.value,
  (periodVal) => {
    const [from, to] = periodVal;
    const isDST = isDateInDST_US();
    criteria.value.from = from
      ? moment(from)
          .subtract(1, "days")
          .format(`YYYY-MM-DD[T]${isDST ? 21 : 22}:00:00.000[Z]`)
      : null;
    criteria.value.to = to
      ? moment(to)
          .subtract(1, "days")
          .format(`YYYY-MM-DD[T]${isDST ? 20 : 21}:59:59.000[Z]`)
      : null;
  }
);

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.export'),
    "is-loading": isLoading.value,
    width: 500,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("title.recordName")), 1),
          _createVNode(_component_el_input, {
            class: "w-400px",
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("fields.type")), 1),
          _createVNode(_component_el_select, {
            modelValue: formData.value.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
            class: "w-400px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.salesRebate'),
                value: _unref(ReportRequestTypes).SalesRebateForTenant
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.salesRebateSumByAccount'),
                value: _unref(ReportRequestTypes).SalesRebateSumByAccountForTenant
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_button, { onClick: resetCriteria }, {
              default: _withCtx(() => [
                _createTextVNode("Reset Conditions")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form, {
            "label-width": "auto",
            class: "border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "mt-3",
                label: "Date"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: period.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((period).value = $event)),
                    type: "daterange",
                    "start-placeholder": _ctx.$t('fields.startDate'),
                    "end-placeholder": _ctx.$t('fields.endDate'),
                    "default-time": defaultTime.value,
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "default-time", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Status" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: criteria.value.status,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.status) = $event)),
                    placeholder: _ctx.$t('fields.status'),
                    disabled: exporting.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "0",
                        label: "Pending"
                      }),
                      _createVNode(_component_el_option, {
                        value: "1",
                        label: "Complete"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Sales UID" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: criteria.value.salesAccountUid,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.salesAccountUid) = $event)),
                    placeholder: "Sales UID",
                    clearable: "",
                    disabled: exporting.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Account #" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: criteria.value.tradeAccountNumber,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.tradeAccountNumber) = $event)),
                    placeholder: "Account Number",
                    clearable: "",
                    disabled: exporting.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Ticket" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: criteria.value.ticket,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.ticket) = $event)),
                    placeholder: "Ticket Number",
                    clearable: "",
                    disabled: exporting.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: exporting.value,
            onClick: submit,
            disabled: !formData.value.type || !formData.value.name
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_el_button, { onClick: hide }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})